<template>
    <div>
        <div v-if="gelen.hataVarMi">
            {{gelen.mesaj}}
        </div>
        <div v-else>
            <div class="container" style="margin-top: 25px;">
                <div class="container">
                    <b-button @click="$router.back()">
                        <b-icon icon="arrow-left"></b-icon>
                        Geri Dön
                    </b-button>

                    <b-button variant="success"
                              @click="sohbetiKapat(gelen.data.kelimeId)"
                              class="ml-2" v-if="kisi.kisiId===gelen.data.kisiId">
                        Okundu Olarak İşaretle 
                    </b-button>

                    <b-button variant="success"
                              class="ml-2" v-if="kisi.yonetici || kisi.kisiId===gelen.data.kisiId"
                              @click="belgeyeGit()">
                        Belgeye Git
                    </b-button>
                </div>

                <okunmayan-kelime :kelime="this.gelen.data" :key="okunamayanKelimeKey"/>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment"
    import {mapGetters} from "vuex"
    import {GoogleTokenIleGirisYapmayiDene} from "@/utils/googlegiris";
    import {kelimeyiOkunduYap, okunamayanKelimeyiGetir, okunmayanKMesajEkle} from "@/api/okunamayan";
    import * as signalR from "@microsoft/signalr"
    import OkunmayanKelime from "@/components/OkunmayanKelime";

    export default {
        name: "sorudetay",
        data() {
            return {
                gelen: {
                    hataVarMi: true,
                    mesaj: "Yükleniyor"
                },
                okunamayanKelimeKey: 0
            }
        },
        methods: {
            async sohbetiKapat(kelimeId) {
                await kelimeyiOkunduYap(kelimeId);
                this.belgeyeGit()
            },
            belgeyeGit() {
                this.$router.push(this.gelen.data.belgeLink);
            },
        },
        computed: {
            ...mapGetters([
                'kisi', 'girisYapmismi'
            ])
        },
        async mounted() {
            if (!this.girisYapmismi)
                await new GoogleTokenIleGirisYapmayiDene(this);

            if (!this.girisYapmismi) {
                this.gelen.mesaj = "Giriş yapmanız lazım";
                this.gelen.hataVarMi = true;
                setTimeout(() => {
                    this.$router.push("/giris-yap?url=" + encodeURI("/kart"))
                }, 3000);
                return
            }

            this.gelen = await okunamayanKelimeyiGetir(this.$route.params.kelimeId);
            //this.mesajlar = this.gelen.data.mesajlar;
            //this.scrollToBottom();

            const that = this;
            this.$signalr.on("mesajeklendi" + this.gelen.data.kelimeId, data => {
                that.gelen.data.mesajlar = data;
                that.okunamayanKelimeKey +=1
                that.scrollToBottom();
            });
        },
        components: {
            OkunmayanKelime,
        }
    }
</script>

<style scoped lang="scss">


</style>
